exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign .btn {\n  height: 0.96rem;\n  line-height: 0.96rem;\n  border-radius: 0.48rem;\n  text-align: center;\n  background-color: #AFAFAF;\n  color: #FFF;\n  margin: 0.5rem auto 0;\n  font-size: 0.32rem;\n  padding: 0 0.5rem 0 0.5rem;\n  max-width: 3rem;\n}\n.sign .btn2 {\n  background-color: #F74D71;\n  position: fixed;\n  bottom: 1rem;\n  left: 50%;\n  -webkit-transform: translate(-50%, 0);\n          transform: translate(-50%, 0);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/app/roomsupport-op/Sign/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/app/roomsupport-op/Sign/index.less
// module chunks = 0